import React, { useState, useEffect } from "react";
import { Image, Table } from "react-bootstrap";
import Switch from "react-switch";
import FilterSection from "../FilterSection";
import ItemsDash, { ItemsBody } from "./ItemsDash";
import PropTypes from "prop-types";
import moment from "moment";

import { connect, useDispatch } from "react-redux";
import { withRouter, NavLink, useParams } from "react-router-dom";
import {
  admin_get_global_catalog_by_catalog_id,
  admin_get_chain_catalog_by_catalog_id,
  admin_update_global_catalog,
  admin_update_chain_catalog,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import {
  GET_ADMIN_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
} from "../../../../../store/types";

// import {
//   GET_ADMIN_MENU_CATEGORY,
//   GET_ADMIN_MENU_CATEGORY_ITEMS,
//   SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
// } from "../";

function GlobalCatalogueView(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [state, setState] = useState(1);
  const [search, setSearch] = useState("");

  const [selectedSort, setSelectedSort] = useState(0);

  const sortByChangeCode = (id) => {
    setSelectedSort(id);
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    if (
      props &&
      props.location &&
      props.location.pathname &&
      props.location.pathname.includes("chain")
    ) {
      props.admin_get_chain_catalog_by_catalog_id(token, id);
    } else {
      props.admin_get_global_catalog_by_catalog_id(token, id);
    }
  }, []);

  const onSuccessDelete = () => {
    const token = props.auth.user.accessToken;
    if (
      props &&
      props.location &&
      props.location.pathname &&
      props.location.pathname.includes("chain")
    ) {
      props.admin_get_chain_catalog_by_catalog_id(token, id);
    } else {
      props.admin_get_global_catalog_by_catalog_id(token, id);
    }
    // Alert.success(`<h4>Item Delete sucessfully</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
  };

  const deleteItem = (id) => {
    const token = props.auth.user.accessToken;

    const formData = {};
    let itemsArray = [...props.active_global_catalog.items];
    let filteredItems = itemsArray.filter((item) => {
      return item._id != id;
    });

    let itemsId = [];

    for (let i = 0; i < filteredItems.length; i++) {
      itemsId.push(filteredItems[i]._id);
    }
    formData.items = itemsId;

    //formData.items = checkedArray;
    if (props.location.pathname.includes("chain")) {
      props.admin_update_chain_catalog(
        token,
        formData,
        props.active_global_catalog._id,
        onSuccessDelete
      );
    } else {
      props.admin_update_global_catalog(
        token,
        formData,
        props.active_global_catalog._id,
        onSuccessDelete
      );
    }
  };

  const changeCatalogStatus = (id, status) => {
    const token = props.auth.user.accessToken;
    const formData = { status: !status };
    if (props.location.pathname.includes("chain")) {
      props.admin_update_chain_catalog(token, formData, id, onSuccessDelete);
    } else {
      props.admin_update_global_catalog(token, formData, id, onSuccessDelete);
    }
  };

  var filteredItems =
    props.active_global_catalog &&
    props.active_global_catalog.items &&
    props.active_global_catalog.items.filter((item) => {
      return (
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.description.toLowerCase().includes(search.toLowerCase())
      );
    });

  filteredItems =
    filteredItems &&
    filteredItems
      .sort((a, b) =>
        selectedSort === 0
          ? a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : -1
          : b.name.toLowerCase() > a.name.toLowerCase()
          ? 1
          : -1
      )
      .filter((offer) => offer);

  // const addNewItem = () => {
  //   dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: "" });
  //   dispatch({ type: GET_VENDOR_MENU_CATEGORY_ITEMS, payload: [] });
  //   history.push("/casual-fine-dining/menusetup/additem");
  // };

  const addNewItemAction = () => {
    let data = {
      actionBy:
        props &&
        props.location &&
        props.location.pathname &&
        props.location.pathname.includes("chain")
          ? "superadmin-chain-catalogue"
          : "superadmin-global-catalogue",
      catId: id,
    };
    if (
      props &&
      props.location &&
      props.location.pathname &&
      props.location.pathname.includes("chain")
    ) {
      props.history.push(`/superadmin-chain-catalogue/add-item`);
    } else {
      props.history.push({
        pathname: `/superadmin-global-catalogue/add-item`,
        state: data,
      });
    }
    dispatch({
      type: GET_ADMIN_MENU_CATEGORY_ITEMS,
      payload: [],
    });
    dispatch({
      type: SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
      payload: "",
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid mt-3">
        {props &&
          props.location &&
          props.location.pathname &&
          props.location.pathname.includes("chain") && (
            <>
              <div className="d-flex">
                <Image src="" width="100px" />
                <div className="">
                  <div className="f24-700">
                    {" "}
                    {props &&
                      props.active_global_catalog &&
                      props.active_global_catalog.restaurant_chain_id &&
                      props.active_global_catalog.restaurant_chain_id.title}
                  </div>

                  <div className="f16-500">
                    Chain ID :{" "}
                    {props &&
                      props.active_global_catalog &&
                      props.active_global_catalog.restaurant_chain_id &&
                      props.active_global_catalog.restaurant_chain_id._id}
                  </div>
                </div>
              </div>
              <hr />
            </>
          )}
        <div className="d-flex justify-content-between ">
          <div className="f24-700">
            {" "}
            {props &&
              props.active_global_catalog &&
              props.active_global_catalog.name}
          </div>

          <div class="d-flex align-items-center  ">
            <NavLink
              to="/superadmin-global-catalogue/assign-item"
              to={
                props &&
                props.location &&
                props.location.pathname &&
                props.location.pathname.includes("chain")
                  ? "/superadmin-chain-catalogue/assign-item"
                  : "/superadmin-global-catalogue/assign-item"
              }
              type="button"
              className="mr-4 px-5 btn-md py-2 btn btn-outline-secondary"
            >
              Assign Item
            </NavLink>
            <button
              type="button"
              className="mr-4 px-5 btn-md py-2 btn btn-danger"
              onClick={() => addNewItemAction()}
            >
              + Add New Item
            </button>
            {/* <NavLink
              to={
                props &&
                props.location &&
                props.location.pathname &&
                props.location.pathname.includes("chain")
                  ? `/superadmin-chain-catalogue/add-item`
                  : `/superadmin-global-catalogue/add-item`
              }
              type="button"
              //onClick={() => addNewItem()}
              className="mr-4 px-5 btn-md py-2 btn btn-danger"
            >
              + Add New Item
            </NavLink> */}
          </div>
        </div>
        <div
          className="row align-items-center mt-3 mb-3 ml-1 mr-1"
          style={{
            boxShadow: "0px 3px 6px #6E6E6E21",
            backgroundColor: "#ffffff",
            borderRadius: "5px",
          }}
        >
          <div
            className="col-1 pb-3 pt-3"
            style={{
              backgroundColor: "#FFCA28",
              borderRadius: "5px 0px 0px 5px",
            }}
            align="center"
          >
            <Image
              src={require("../../../../../assets/images/Icon/menu.svg")}
              width="20px"
            />
          </div>
          <div className="col-8  pb-3 pt-3">
            <div className="f14-500">
              {" "}
              {props &&
                props.active_global_catalog &&
                props.active_global_catalog.name}
            </div>
          </div>
          <div className="col-3  pb-3 pt-3 pr-4" align="right">
            <div className="f14-500">
              ID : #{" "}
              {props &&
                props.active_global_catalog &&
                props.active_global_catalog._id}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-5">
            <div className="f12-500">Description</div>
          </div>
          <div className="col-2">
            <div className="f12-500">No. of Items</div>
          </div>
          <div className="col-2">
            <div className="f12-500">Status</div>
          </div>
          <div className="col-2">
            <div className="f12-500">Created Date & Time</div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-5">
            <div className="f12-400">
              {props &&
                props.active_global_catalog &&
                props.active_global_catalog.description}
            </div>
          </div>
          <div className="col-2">
            <div className="f12-400">
              {props &&
                props.active_global_catalog &&
                props.active_global_catalog.items &&
                props.active_global_catalog.items.length}
            </div>
          </div>
          <div className="col-2">
            <div className="f12-400">
              <Switch
                //   onChange={() => {}}
                onChange={() =>
                  changeCatalogStatus(
                    props.active_global_catalog._id,
                    props.active_global_catalog.status
                  )
                }
                checked={
                  props &&
                  props.active_global_catalog &&
                  props.active_global_catalog.status
                }
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              />
            </div>
          </div>
          <div className="col-2">
            <div className="f12-400">
              {moment(
                props &&
                  props.active_global_catalog &&
                  props.active_global_catalog.createdAt
              ).format("Do MMMM YYYY, h:mm a")}
            </div>
          </div>
        </div>
        <hr />
        <FilterSection
          state={state}
          search={search}
          onChange={(e) => setSearch(e)}
          sortByChangeCode={(id) => sortByChangeCode(id)}
          selectedSort={selectedSort}
        />
        {/* <div className="d-flex mt-3">
          <div
            className={`mr-3 ${state === 1 && `selected-tab`} cursor-pointer`}
            onClick={() => {
              setState(1);
            }}
          >
            Items
          </div>
          <div
            className={`mr-3 ${state === 2 && `selected-tab`} cursor-pointer`}
            onClick={() => {
              setState(2);
            }}
          >
            Category
          </div>
          <div
            className={`mr-3 ${state === 3 && `selected-tab`} cursor-pointer`}
            onClick={() => {
              setState(3);
            }}
          >
            Add Ons
          </div>
        </div> */}
        {/* {state === 1 && ( */}
        <div className="col-12 p-0  user-table-reusable-superadmin ">
          <Table>
            <thead>
              <ItemsDash />
            </thead>
            {filteredItems &&
              filteredItems.map((item, index) => (
                <ItemsBody
                  key={index}
                  item={item}
                  deleteItem={() => deleteItem(item._id)}
                  show={false}
                  // changeItemStatus={() =>
                  //   changeItemStatus(item._id, item.status)
                  // }
                />
              ))}
          </Table>
        </div>
        {/* )} */}
      </div>
    </React.Fragment>
  );
}

// export default GlobalCatalogueView;

GlobalCatalogueView.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  active_global_catalog: state.commonSuperAdmin.active_global_catalog,
});

export default connect(mapStateToProps, {
  admin_get_global_catalog_by_catalog_id,
  admin_get_chain_catalog_by_catalog_id,
  admin_update_global_catalog,
  admin_update_chain_catalog,
})(withRouter(GlobalCatalogueView));
